export enum AttributeType {
  NONE = 0,
  SUBJECT_NAME = 1,
  GREETING = 2,
  DONOR_NAME = 3,
}
